import { z } from "zod";
export const GetTortusAvtLaunchTokenRequestSchema = z.object({
    formDraftId: z.uuid().optional(),
    patientId: z.uuid().optional(),
});
//# sourceMappingURL=tortusAvt.js.map